import type { IAccountInfoModel } from './Types';

export default (accountInfo: IAccountInfoModel) => {
  const { accountName, accountType, accountLast4 } = accountInfo;
  return {
    accountName: accountName && String(accountName),
    accountType: accountType && String(accountType),
    accountLast4: accountLast4 && String(accountLast4),
  };
};
